import React, { useState, useEffect, useContext } from "react";

import { Box, Button, IconButton, Paper, TableContainer, TableBody, TableCell, TableHead, TableRow, Table, Typography } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { isEmpty } from "lodash";
import { DataContext } from "../../../context/DataContext";
import { isAccess, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import NoData from "../../../components/NoData";

import SmallModal from "../../../components/modals/SmallModal";

import { getSucursalListAsync } from "../../../api/Sucursal";
import AddSucursal from "./AddSucursal";
import EditSucursal from "./EditSucursal";
import { monoFont } from "../../../theme";

const SucursalList = () => {
  const [sucursalList, setSucursalList] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [localReload, setLocalReload] = useState(false);

  const { access, setIsLoading, setIsUnautorized } = useContext(DataContext);

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getSucursalListAsync(token);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setSucursalList(result.data.result);
    })();
  }, [localReload]);

  return (
    <div>
      <Paper sx={{ overflow: "hidden" }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px", borderBottom: "1px solid", borderColor: "divider" }}>
          <Typography sx={{ fontSize: 15, fontWeight: 600 }}>Sucursales</Typography>
          {isAccess(access, "CREAR SUCURSAL") ? (
            <Button onClick={() => setShowModal(true)} variant="contained" color="primary" size="small" startIcon={<AddRoundedIcon sx={{ fontSize: 17 }} />}>
              Agregar
            </Button>
          ) : null}
        </Box>

        {isEmpty(sucursalList) ? (
          <NoData />
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Sucursal</TableCell>
                  {isAccess(access, "EDITAR SUCURSAL") ? <TableCell align="center">Editar</TableCell> : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {sucursalList.map((row) => {
                  const { id, description } = row;
                  return (
                    <TableRow key={id}>
                      <TableCell sx={{ fontFamily: monoFont, color: "text.disabled" }}>{id}</TableCell>
                      <TableCell sx={{ fontWeight: 500 }}>{description}</TableCell>
                      {isAccess(access, "EDITAR SUCURSAL") ? (
                        <TableCell align="center">
                          <IconButton
                            size="small"
                            onClick={() => {
                              setSelectedSucursal(row);
                              setShowEditModal(true);
                            }}
                          >
                            <EditRoundedIcon sx={{ fontSize: 17 }} />
                          </IconButton>
                        </TableCell>
                      ) : null}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>

      <SmallModal titulo={"Agregar Sucursal"} isVisible={showModal} setVisible={setShowModal}>
        <AddSucursal setShowModal={setShowModal} localReload={localReload} setLocalReload={setLocalReload} />
      </SmallModal>

      <SmallModal titulo={`Editar sucursal`} isVisible={showEditModal} setVisible={setShowEditModal}>
        <EditSucursal selected={selectedSucursal} setShowModal={setShowEditModal} localReload={localReload} setLocalReload={setLocalReload} />
      </SmallModal>
    </div>
  );
};

export default SucursalList;
